import create from 'zustand'
import { WritableDraft } from 'immer/dist/internal'
import { immer } from 'zustand/middleware/immer'
import { DegreeViewDegreeFragment } from '@/graphql/generated/graphql'
import { Theme } from './theme'

type State = {
  theme?: Theme
}

interface Actions {
  setState: (updater: (state: WritableDraft<State>) => void) => void
  reset: () => void
}

export const initialState: State = {
  theme: undefined,
}

export const useViewStore = create<State & Actions>()(
  immer((set, get) => ({
    ...initialState,
    setState: (e) => {
      return set(e, undefined)
    },
    reset: () => {
      set(initialState)
    },
  })),
)
